import "../src/css/style.css";
import Home from "./js/pages/Home";
import React from "react";

function App() {
  return (
    <>
      <Home />
    </>
  );
}

export default App;
